import {changeEvent, dispatchCustomEvent} from "../../../../../../../webpack/modules/events";
import {isDesktop} from "../../../../../../../webpack/modules/devices";

changeEvent('#product-list-page .product-configuration-chainPosition[data-option-type="selectable"] input[name="chain-position"]', true, function(element) {
    let mainContainer = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration');
    let previewElement = mainContainer.querySelector('.open-configuration .preview-option-chainPosition');

    dispatchCustomEvent(
        'productChainPositionChanged',
        {
            'option': container,
            'previewElement': previewElement
        }
    );
    container.querySelectorAll('.chain-position.selected').forEach(option => option.classList.remove('selected'));
    element.nextElementSibling.classList.add('selected');
    mainContainer.querySelector('input[name="option-chainPosition"]').value = element.value;
    container.dataset.completed = 'true';
    dispatchCustomEvent('productListProductConfigurationChanged');
});